<template>
  <header class="hdr">
    <div class="inner">
      <button class="brand" :aria-label="hotelName || 'Seth Hotels'" @click="navigateLanding(false)">
        <img :src="logo" :alt="hotelName || 'Seth Hotels'" class="logo" />
      </button>

      <div v-if="store.idiomas.length" class="lang-dd" :class="{ open: langOpen }">
        <button
          class="lang-toggle"
          type="button"
          aria-haspopup="listbox"
          :aria-expanded="langOpen ? 'true' : 'false'"
          @click.stop="langOpen = !langOpen"
        >
          <img v-if="current && current.bandera" :src="current.bandera" :alt="current.nombre" class="flag" loading="lazy" />
          <span>{{ store.locale.toUpperCase() }}</span>
          <svg class="chev" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m6 9 6 6 6-6" /></svg>
        </button>
        <ul v-if="langOpen" class="lang-menu" role="listbox">
          <li
            v-for="l in store.idiomas"
            :key="l.locale"
            class="lang-item"
            :class="{ active: l.locale === store.locale }"
            role="option"
            :aria-selected="l.locale === store.locale ? 'true' : 'false'"
            @click="pickLocale(l.locale)"
          >
            <img v-if="l.bandera" :src="l.bandera" :alt="l.nombre" class="flag" loading="lazy" />
            <span>{{ l.nombre }}</span>
          </li>
        </ul>
      </div>

      <button class="mine-btn" :class="{ active: store.view === 'mine' }" @click="toggleView">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21a8 8 0 0 0-16 0" /><circle cx="12" cy="7" r="4" /></svg>
        <span>{{ ui.mis }}</span>
        <span v-if="store.mine.length" class="count">{{ store.mine.length }}</span>
      </button>
    </div>
  </header>
</template>

<script>
import { UI } from '@/data'
import { store, setLocale, toggleView, navigateLanding } from '@/store'
import logo from '@/assets/seth-logo.png'

export default {
  name: 'AppHeader',
  props: {
    hotelName: { type: String, default: '' }
  },
  data() {
    return { store, logo, langOpen: false }
  },
  computed: {
    ui() { return UI[store.locale] || UI.es },
    current() { return store.idiomas.find(l => l.locale === store.locale) || null }
  },
  mounted() {
    this._closeLang = () => { this.langOpen = false }
    document.addEventListener('click', this._closeLang)
  },
  beforeUnmount() {
    document.removeEventListener('click', this._closeLang)
  },
  methods: {
    setLocale,
    toggleView,
    navigateLanding,
    pickLocale(locale) {
      setLocale(locale)
      this.langOpen = false
    }
  }
}
</script>

<style scoped>
.hdr {
  position: sticky;
  top: 0;
  z-index: 30;
  background: rgba(255, 255, 255, 0.92);
  backdrop-filter: blur(10px);
  border-bottom: 1px solid var(--sand-200);
}
.inner {
  max-width: 1180px;
  margin: 0 auto;
  padding: 12px clamp(16px, 4vw, 40px);
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}
.brand {
  display: flex;
  align-items: center;
  margin-right: auto;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
}
.logo { height: 38px; width: auto; display: block; }

.lang-dd {
  position: relative;
}
.lang-toggle {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border: 1px solid var(--sand-300);
  cursor: pointer;
  padding: 8px 12px;
  border-radius: 999px;
  font-family: var(--font-sans);
  font-weight: 700;
  font-size: 0.8rem;
  letter-spacing: 0.04em;
  transition: all 160ms;
  background: #fff;
  color: var(--seth-navy);
  white-space: nowrap;
}
.lang-dd.open .lang-toggle { border-color: var(--seth-navy); }
.chev { transition: transform 180ms; opacity: 0.6; }
.lang-dd.open .chev { transform: rotate(180deg); }
.flag {
  width: 18px;
  height: 13px;
  border-radius: 2px;
  object-fit: cover;
  display: block;
  flex-shrink: 0;
}
.lang-menu {
  position: absolute;
  top: calc(100% + 6px);
  right: 0;
  z-index: 40;
  margin: 0;
  padding: 6px;
  list-style: none;
  min-width: 168px;
  max-height: 320px;
  overflow-y: auto;
  background: #fff;
  border: 1px solid var(--sand-200);
  border-radius: 14px;
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.12);
}
.lang-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 9px 12px;
  border-radius: 9px;
  cursor: pointer;
  font-family: var(--font-sans);
  font-weight: 600;
  font-size: 0.86rem;
  color: var(--ink-500);
  transition: background 140ms;
}
.lang-item:hover { background: var(--sand-100); }
.lang-item.active { background: var(--seth-navy); color: #fff; }

.mine-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 9px 16px;
  border-radius: 999px;
  cursor: pointer;
  font-family: var(--font-sans);
  font-weight: 600;
  font-size: 0.9rem;
  transition: all 180ms;
  background: #fff;
  color: var(--seth-navy);
  border: 1px solid var(--sand-300);
}
.mine-btn.active { background: var(--seth-navy); color: #fff; border-color: var(--seth-navy); }
.count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 20px;
  padding: 0 5px;
  border-radius: 999px;
  background: var(--seth-gold);
  color: var(--seth-navy);
  font-size: 0.72rem;
  font-weight: 700;
}
</style>
